angular.module('impactx.lot').controller('NewestLotCtrl', [
    '$scope',
    'dataGen',
    'ToolbarService',
    NewestLotCtrl
]);

function NewestLotCtrl($scope, dataGen, ToolbarService) {
    ToolbarService.setButtons([]);
    dataGen.getData($scope, {}, "/lot/newest");

    $scope.hasLots = function() {
        return $scope.data.numOfLots > 0
    }
}